import React from "react";
import { List } from "antd";
import AccountSidebar from "../../../../components/AccountSidebar";
import { useAuth } from "../../../../contexts/auth";
import PageHeader from "../../../../components/PageHeader";
import { addressToString } from "../../../../utils/formatter";

const CompanyProfilePage = () => {
  const auth = useAuth();
  const user = auth.loggedInUser;
  const company = user.company;
  const data = [
    {
      title: "Name",
      desc: company.companyName,
    },
    {
      title: "PAN",
      desc: company.pan || "N/A",
    },
    {
      title: "GST",
      desc: company.gst || "N/A",
    },
    {
      title: "CIN",
      desc: company.cin || "N/A",
    },
    {
      title: "Registered Address",
      desc: addressToString(company.registeredAddress),
    },
  ];

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <AccountSidebar />
      <div style={{ flex: 1 }}>
        <PageHeader title="Company Details" />
        <List
          itemLayout="horizontal"
          dataSource={data}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta title={item.title} description={item.desc} />
            </List.Item>
          )}
        />
      </div>
    </div>
  );
};

export default CompanyProfilePage;
